import { actionCreators as counter } from './counter/actions'
export default {counter}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/redux/actions.ts